export const save = (module, context) => {
  localStorage.setItem(`${module}State`, JSON.stringify(context.state))
}

export const load = module => {
  const stateStr = localStorage.getItem(`${module}State`)
  if (!stateStr) return null
  return JSON.parse(stateStr)
}
